const stroke = "rgba(232,240,247,0.75)";

const Inverter = ({ accent }) => (
    <svg viewBox="0 0 220 150" className="w-full h-full" role="img" aria-label="Smarten inverter illustration">
        <defs>
            <linearGradient id="inv-body" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#102340" />
                <stop offset="100%" stopColor="#0B1B33" />
            </linearGradient>
        </defs>
        <rect x="45" y="25" width="130" height="100" rx="12" fill="url(#inv-body)" stroke={stroke} strokeWidth="1.5" />
        <rect x="60" y="42" width="64" height="34" rx="5" fill="#07111F" stroke={accent} strokeWidth="1" opacity="0.9" />
        <path d="M66 59 q6 -12 12 0 t12 0 t12 0 t12 0" fill="none" stroke={accent} strokeWidth="2" className="animate-energy" />
        <circle cx="150" cy="50" r="4" fill={accent} className="animate-pulse-dot" />
        <circle cx="163" cy="50" r="4" fill="#FFD21F" className="animate-pulse-dot" style={{ animationDelay: "0.6s" }} />
        <rect x="60" y="90" width="100" height="6" rx="3" fill="#07111F" />
        <rect x="60" y="90" width="62" height="6" rx="3" fill={accent} opacity="0.8" className="animate-energy" />
        <rect x="80" y="125" width="14" height="8" rx="2" fill="#102340" stroke={stroke} strokeWidth="1" />
        <rect x="126" y="125" width="14" height="8" rx="2" fill="#102340" stroke={stroke} strokeWidth="1" />
    </svg>
);

const Battery = ({ accent }) => (
    <svg viewBox="0 0 220 150" className="w-full h-full" role="img" aria-label="Inverter battery illustration">
        <defs>
            <linearGradient id="bat-fill" x1="0" y1="1" x2="0" y2="0">
                <stop offset="0%" stopColor={accent} stopOpacity="0.85" />
                <stop offset="100%" stopColor={accent} stopOpacity="0.25" />
            </linearGradient>
        </defs>
        <rect x="80" y="18" width="60" height="10" rx="3" fill="#102340" stroke={stroke} strokeWidth="1.2" />
        <rect x="62" y="28" width="96" height="104" rx="10" fill="#0B1B33" stroke={stroke} strokeWidth="1.5" />
        <rect x="70" y="66" width="80" height="58" rx="6" fill="url(#bat-fill)" className="animate-energy" />
        <line x1="70" y1="52" x2="150" y2="52" stroke={stroke} strokeWidth="1" opacity="0.4" />
        <line x1="70" y1="66" x2="150" y2="66" stroke={accent} strokeWidth="1.4" opacity="0.9" />
        <path d="M112 78 l-12 16 h9 l-5 14 16 -19 h-10 l6 -11 z" fill="#FFFFFF" opacity="0.9" />
        <circle cx="92" cy="22" r="3.5" fill={accent} />
        <circle cx="128" cy="22" r="3.5" fill="#FF5C5C" />
    </svg>
);

const Lithium = ({ accent }) => (
    <svg viewBox="0 0 220 150" className="w-full h-full" role="img" aria-label="Lithium battery illustration">
        <rect x="40" y="40" width="140" height="72" rx="10" fill="#0B1B33" stroke={stroke} strokeWidth="1.5" />
        <rect x="40" y="40" width="140" height="20" rx="10" fill="#102340" stroke={stroke} strokeWidth="1" />
        <text x="52" y="55" fill={accent} fontSize="10" fontFamily="JetBrains Mono, monospace">Li</text>
        {[0, 1, 2, 3, 4, 5].map((i) => (
            <rect key={i} x={54 + i * 20} y="72" width="13" height="28" rx="3" fill="#07111F" stroke={accent} strokeWidth="1" className="animate-energy" style={{ animationDelay: `${i * 0.25}s` }} />
        ))}
        <circle cx="168" cy="50" r="4" fill={accent} className="animate-pulse-dot" />
        <line x1="60" y1="112" x2="60" y2="126" stroke={stroke} strokeWidth="2" />
        <line x1="160" y1="112" x2="160" y2="126" stroke={stroke} strokeWidth="2" />
    </svg>
);

const Solar = ({ accent }) => (
    <svg viewBox="0 0 220 150" className="w-full h-full" role="img" aria-label="Solar panels illustration">
        <defs>
            <linearGradient id="sol-face" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#123063" />
                <stop offset="100%" stopColor="#0B1B33" />
            </linearGradient>
            <clipPath id="sol-clip">
                <polygon points="45,110 175,110 155,55 65,55" />
            </clipPath>
        </defs>
        <circle cx="176" cy="32" r="15" fill={accent} opacity="0.9" />
        <circle cx="176" cy="32" r="24" fill="none" stroke={accent} strokeWidth="1" opacity="0.35" className="animate-pulse-dot" />
        <polygon points="45,110 175,110 155,55 65,55" fill="url(#sol-face)" stroke={stroke} strokeWidth="1.5" />
        <g clipPath="url(#sol-clip)">
            {[0, 1, 2, 3].map((i) => (
                <line key={`v${i}`} x1={74 + i * 26} y1="55" x2={62 + i * 26} y2="110" stroke="rgba(0,207,255,0.45)" strokeWidth="1" />
            ))}
            {[0, 1, 2].map((i) => (
                <line key={`h${i}`} x1="40" y1={69 + i * 14} x2="180" y2={69 + i * 14} stroke="rgba(0,207,255,0.45)" strokeWidth="1" />
            ))}
            <rect x="0" y="45" width="34" height="80" fill="rgba(255,255,255,0.16)" className="animate-panel-sweep" />
        </g>
        <line x1="85" y1="110" x2="85" y2="132" stroke={stroke} strokeWidth="2.5" />
        <line x1="135" y1="110" x2="135" y2="132" stroke={stroke} strokeWidth="2.5" />
        <line x1="65" y1="132" x2="155" y2="132" stroke={stroke} strokeWidth="2.5" />
    </svg>
);

const SolarSetup = ({ accent }) => (
    <svg viewBox="0 0 220 150" className="w-full h-full" role="img" aria-label="Complete solar setup illustration">
        <polygon points="28,62 76,62 68,34 36,34" fill="#123063" stroke={stroke} strokeWidth="1.2" />
        <line x1="44" y1="34" x2="40" y2="62" stroke="rgba(0,207,255,0.5)" strokeWidth="1" />
        <line x1="58" y1="34" x2="54" y2="62" stroke="rgba(0,207,255,0.5)" strokeWidth="1" />
        <rect x="96" y="30" width="30" height="36" rx="5" fill="#0B1B33" stroke={stroke} strokeWidth="1.2" />
        <path d="M114 36 l-7 11 h5 l-3 9 9 -12 h-5 l3 -8 z" fill={accent} />
        <rect x="150" y="34" width="44" height="30" rx="6" fill="#0B1B33" stroke={stroke} strokeWidth="1.2" />
        <rect x="154" y="40" width="26" height="18" rx="3" fill={accent} opacity="0.35" className="animate-energy" />
        <path d="M52 66 C 52 92, 88 92, 104 70" fill="none" stroke={accent} strokeWidth="1.6" className="dash-flow" />
        <path d="M126 48 h24" fill="none" stroke={accent} strokeWidth="1.6" className="dash-flow" />
        <path d="M172 64 C 172 96, 118 100, 112 100" fill="none" stroke={accent} strokeWidth="1.6" className="dash-flow" />
        <path d="M104 84 l7 14 h16 l7 -14 z M100 100 h32 M104 108 h24" fill="none" stroke={stroke} strokeWidth="1.6" />
        <circle cx="116" cy="96" r="2.4" fill={accent} className="animate-pulse-dot" />
    </svg>
);

const Cctv = ({ accent }) => (
    <svg viewBox="0 0 220 150" className="w-full h-full" role="img" aria-label="CCTV camera illustration">
        <defs>
            <linearGradient id="cctv-cone" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={accent} stopOpacity="0.35" />
                <stop offset="100%" stopColor={accent} stopOpacity="0" />
            </linearGradient>
        </defs>
        <rect x="98" y="14" width="24" height="12" rx="3" fill="#102340" stroke={stroke} strokeWidth="1.2" />
        <path d="M70 40 a40 40 0 0 1 80 0 z" fill="#0B1B33" stroke={stroke} strokeWidth="1.5" />
        <path d="M78 40 a32 32 0 0 1 64 0 z" fill="#07111F" stroke={accent} strokeWidth="1" opacity="0.85" />
        <circle cx="110" cy="26" r="9" fill="#07111F" stroke={accent} strokeWidth="1.6" />
        <circle cx="110" cy="26" r="3.4" fill={accent} className="animate-pulse-dot" />
        <g className="animate-swing">
            <polygon points="110,42 62,132 158,132" fill="url(#cctv-cone)" />
            <line x1="110" y1="42" x2="62" y2="132" stroke={accent} strokeWidth="1" opacity="0.5" />
            <line x1="110" y1="42" x2="158" y2="132" stroke={accent} strokeWidth="1" opacity="0.5" />
        </g>
        <circle cx="152" cy="20" r="4" fill="#FF4D4D" className="animate-rec" />
    </svg>
);

const Broadband = ({ accent }) => (
    <svg viewBox="0 0 220 150" className="w-full h-full" role="img" aria-label="Broadband router illustration">
        <rect x="66" y="96" width="88" height="26" rx="8" fill="#0B1B33" stroke={stroke} strokeWidth="1.5" />
        <circle cx="82" cy="109" r="3.4" fill={accent} className="animate-pulse-dot" />
        <circle cx="96" cy="109" r="3.4" fill={accent} className="animate-pulse-dot" style={{ animationDelay: "0.5s" }} />
        <circle cx="110" cy="109" r="3.4" fill="#FFD21F" className="animate-pulse-dot" style={{ animationDelay: "1s" }} />
        <line x1="140" y1="96" x2="140" y2="62" stroke={stroke} strokeWidth="2.4" />
        <circle cx="140" cy="58" r="3.4" fill={accent} />
        <path d="M126 46 a20 20 0 0 1 28 0" fill="none" stroke={accent} strokeWidth="2" className="animate-wifi-1" />
        <path d="M118 34 a32 32 0 0 1 44 0" fill="none" stroke={accent} strokeWidth="2" className="animate-wifi-2" />
        <path d="M110 22 a44 44 0 0 1 60 0" fill="none" stroke={accent} strokeWidth="2" className="animate-wifi-3" />
        <circle cx="52" cy="70" r="4" fill="none" stroke={accent} strokeWidth="1.4" />
        <circle cx="52" cy="70" r="4" fill="none" stroke={accent} strokeWidth="1.4" className="animate-node-ping" />
        <line x1="56" y1="76" x2="70" y2="98" stroke={accent} strokeWidth="1" opacity="0.5" className="dash-flow" />
    </svg>
);

const Ev = ({ accent }) => (
    <svg viewBox="0 0 220 150" className="w-full h-full" role="img" aria-label="EV charger illustration">
        <rect x="70" y="28" width="80" height="74" rx="12" fill="#0B1B33" stroke={stroke} strokeWidth="1.5" />
        <circle cx="110" cy="56" r="15" fill="none" stroke={accent} strokeWidth="1.5" />
        <path d="M114 45 l-9 13 h6 l-4 13 12 -15 h-7 l4 -11 z" fill={accent} className="animate-energy" />
        <rect x="86" y="82" width="48" height="6" rx="3" fill="#07111F" stroke={accent} strokeWidth="1" opacity="0.8" />
        <path d="M150 72 C 188 82, 184 112, 160 116" fill="none" stroke={stroke} strokeWidth="3" />
        <rect x="148" y="110" width="24" height="14" rx="4" fill="#102340" stroke={stroke} strokeWidth="1.2" />
        <line x1="154" y1="110" x2="154" y2="103" stroke={stroke} strokeWidth="2" />
        <line x1="166" y1="110" x2="166" y2="103" stroke={stroke} strokeWidth="2" />
        <circle cx="52" cy="112" r="11" fill="none" stroke={accent} strokeWidth="1.5" />
        <circle cx="52" cy="112" r="11" fill="none" stroke={accent} strokeWidth="1" className="animate-node-ping" />
        <circle cx="52" cy="112" r="3" fill={accent} className="animate-pulse-dot" />
        <line x1="63" y1="112" x2="70" y2="100" stroke={accent} strokeWidth="1" opacity="0.5" className="dash-flow" />
    </svg>
);

const ART_MAP = {
    inverter: Inverter,
    battery: Battery,
    lithium: Lithium,
    solar: Solar,
    solarSetup: SolarSetup,
    cctv: Cctv,
    broadband: Broadband,
    ev: Ev,
};

export default function ProductArt({ type, accent = "#00CFFF" }) {
    const Art = ART_MAP[type] || Inverter;
    return (
        <div
            className="w-full h-full flex items-center justify-center"
            style={{ filter: `drop-shadow(0 0 22px ${accent}33)` }}
        >
            <Art accent={accent} />
        </div>
    );
}
